import { useTheme } from "@mui/material";
import List from "@mui/material/List";
import _ from "lodash";
import React from "react";
import NoChannelPlaceholder from "src/Chat/component/NoChannelPlaceholder";
import { useChannelListStyles } from "src/Chat/component/styles";
import { SelectedChannel } from "../../types";
import * as api from "../api";
import ChannelInfo from "./ChannelInfo";

interface Props {
	channels: api.Conversation[];
	selected?: SelectedChannel;
	onSelectChannel?: (channel: SelectedChannel) => void;
	onNavigateChannel?: (channel: SelectedChannel) => void;
}

const ChannelsList: React.FunctionComponent<Props> = ({ channels, selected, onSelectChannel, onNavigateChannel }) => {
	const classes = useChannelListStyles(useTheme());
	if (null == channels || 0 === channels.length) {
		return (
			<NoChannelPlaceholder />
		);
	}

	return (
		<List component="nav" sx={classes.root}>
			{
				_.orderBy(channels, ["name"], ["asc"])
					.map((conversation) => {
						const { id, name, member, private: isPrivate } = conversation;
						const channel = new SelectedChannel(id, name, member, isPrivate);
						const handleOnSelect = onSelectChannel ? () => onSelectChannel(channel) : null;
						const handleOnNavigate = onNavigateChannel ? () => onNavigateChannel(channel) : null;
						return (
							<ChannelInfo
								channel={conversation}
								key={conversation.id}
								onNavigate={handleOnNavigate}
								onSelect={handleOnSelect}
								selected={selected?.channelId === channel.channelId}
							/>
						);
					})
			}
		</List>
	);
};

export default ChannelsList;